import { useContext } from 'react';
import { RecurringItemContext } from './RecurringItem.provider';

/**
 * Hook to use the Sequential PO Number context
 * @returns
 */
const useRecurringItemContext = () => {
    const context = useContext(RecurringItemContext);
    if (!context) {
        throw new Error('useRecurringItemContext must be used within a RecurringItemContextProvider');
    }
    return context;
};

export default useRecurringItemContext;
